export default __webpack_public_path__ + "static/media/Hatchback_dog5.68b6d070.webp";